import { combineReducers } from 'redux'
import letters from './letters'
import word from './word'


export default combineReducers({
  letters,
  word
})
